import mark from "./assets/brand-mark.png";
import "./brand.css";

export default function Brand({ wordmark = false }) {
  return <span className={`brand-identity${wordmark ? " brand-identity-full" : ""}`}>
    <img src={mark} alt={wordmark ? "" : "Smart Remote EA Assistant"} />
    {wordmark && <span>SMART REMOTE<br />EA ASSISTANT</span>}
  </span>;
}
